import { useEffect } from "react";
import { useParams } from "react-router-dom";

function Centralisation() {

  const { schoolId } = useParams();


  useEffect(() => {
    window.location.replace("https://cleezoclass.com/Admission/");
  }, []);

  return <h2>Opening Admission...</h2>;
}

export default Centralisation;